import Image from '@repo/ui/src/components/Image/New';
import React from 'react';
import ProductPrice from '@components/Product/Price';
import Product from '@models/product';
import { classNames } from '@repo/ui/src/utils/classNames';
import { Promotions } from '@typings/product';

interface PromotionsProps {
  product: Product;
  promotions?: Array<Promotions>;
  customizable?: boolean;
  dark?: boolean;
  className?: string;
  isNewTemplate?: boolean;
}

const PromotionsAndPricing = ({
  product,
  promotions,
  customizable = false,
  dark = false,
  className,
  isNewTemplate,
}: PromotionsProps) => {
  if (customizable && !promotions?.length) {
    return null;
  }
  const newPromotions = promotions?.slice(0, 2);

  return (
    <div className={classNames('tw-flex-row tw-text-center tw-gap-6', className)}>
      {!customizable && (
        <ProductPrice
          product={product}
          component="h5"
          variant="h5"
          className="tra-text-web-heading-5 tw-items-center tw-w-auto [&_del]:tw-text-neutral-400 [&_del]:tw-justify-self-center"
          color={dark ? 'white' : undefined}
        />
      )}
      {isNewTemplate && (
        <ul
          className="tw-flex tw-flex-row tw-flex-wrap tw-gap-x-6 tw-justify-center tw-list-none tw-pl-0"
          aria-label="promotions"
        >
          {newPromotions?.map((promotion, i) => (
            <li
              key={i}
              className="tw-flex tw-flex-row tw-gap-2 tw-justify-center tw-items-center tw-text-center"
            >
              {promotion.icon && (
                <Image src={promotion.icon} width={24} height={24} alt={promotion?.title} />
              )}
              <p className={classNames('tra-text-web-utl-label', dark && 'tw-text-white')}>
                {promotion.title}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PromotionsAndPricing;
